export const elements = {
  cover: 'cover',
  title: 'title',
  self: 'self'
}
export const types = {
  three: 'news_detail_three',
  four: 'news_detail_four'
}
